import { createBatchSender, stringifyBatch } from '@slardar/sdk-template';
import { getBeaconTransport } from './transports';
import { onPageUnload } from './utils';
// istanbul ignore not working for export { ... } from statements
// https://github.com/istanbuljs/nyc/issues/1209
/* istanbul ignore next */
export { createBatchSender } from '@slardar/sdk-template';
// createSender has side effects(register onClose behaviour)
// so it must be create lazily
export function createBrowserSender(config) {
    var sender = createBatchSender(config);
    var beaconTransport = getBeaconTransport();
    var sendOnClose = function (data) {
        beaconTransport.post(sender.getEndpoint(), stringifyBatch([data]));
    };
    onPageUnload(function () {
        var data = sender.getBatchData();
        if (data) {
            beaconTransport.post(sender.getEndpoint(), data);
            sender.clear();
        }
        sender.send = sendOnClose;
    });
    return sender;
}
//# sourceMappingURL=sender.js.map